import { Field, Form, Formik } from "formik"

import { REVENUE_OPTIONS, useConnect } from "./connect"
import { Button, FormField, Select } from "~/ui-rtk/components/ui/controls"
import { useMemo } from "react"
import { ErrorBlock } from "~/ui-rtk/utils/form"

const AccountDetailsForm = () => {
  const {
    isSubmitting,
    initialValues,
    validationSchema,
    updateAccountDetails,
  } = useConnect()

  const revenueOptions = useMemo(
    () => [
      {
        value: undefined,
        label: "Select Estimate Revenue",
      },
      ...REVENUE_OPTIONS,
    ],
    [],
  )

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={updateAccountDetails}
      validationSchema={validationSchema}
    >
      {({ touched, errors, setFieldValue }) => (
        <Form className="flex flex-col items-center w-full space-y-8">
          <div className="flex flex-col items-center w-full gap-5.5">
            <FormField
              id="companyName"
              type="text"
              placeholder="Company name"
              className="py-4"
              isError={Boolean(touched.companyName && errors.companyName)}
            />
            <FormField
              id="domain"
              type="text"
              placeholder="Company Domain"
              className="py-4"
              isError={Boolean(touched.domain && errors.domain)}
            />
            <div className="w-full">
              <Field
                id="revenueEstimate"
                name="revenueEstimate"
                type="string"
                as={Select}
                options={revenueOptions}
                className="bg-white py-1.5"
                isError={Boolean(
                  touched.revenueEstimate && errors.revenueEstimate,
                )}
                onChange={(ev: React.ChangeEvent<HTMLSelectElement>) => {
                  void setFieldValue("revenueEstimate", ev.target.value)
                }}
              />
              <ErrorBlock error={errors.revenueEstimate} />
            </div>
          </div>
          <Button
            type="submit"
            size="lg"
            className="sm:max-w-48 w-full"
            isLoading={isSubmitting}
          >
            Continue
          </Button>
        </Form>
      )}
    </Formik>
  )
}

export default AccountDetailsForm
